// extracted by mini-css-extract-plugin
export default {"div":"EditableTableField_div__lXerj","input":"EditableTableField_input__1CXaO"};